import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import {
  Grid,
  Row,
  Panel,
  Button,
  Breadcrumb,
  ButtonToolbar,
} from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import axios from 'axios';

import BusinessUsersModal from './businessUsersModal';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { companyCodeTitle } from '../../actions/root_url';
import { USER_PUT_NOTE_URL, USER_QUERY_NOTE_URL } from '../../actions/url';


const tableHeight = (window.innerHeight < 930) ? 650 : 650;

class UserManagement extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      messages: {
        rows: [],
        selectedRows: null,
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      businessUsersModalOpen: false,
      messageModalOpen: false,
      message: '',
      userId: '',
      replyMessage: '',
      replyFile: null,
      isLoading: false,
      error: '',
    };
    this.handleChangeMessage = this.handleChangeMessage.bind(this);
    this.handleChangeFile = this.handleChangeFile.bind(this);
    this.setReplyModalVisibility = this.setReplyModalVisibility.bind(this);
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    this.getMessageListById();
  }

  getMessageListById() {
    const { id } = this.context.router.params;
    if (!id) {
      return;
    }
    const data = new FormData();
    data.append('pk', id);
    axios.post(
      USER_QUERY_NOTE_URL,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      if (response.status !== 200) {
        return;
      }
      const messages = { ...this.state.messages, rows: JSON.parse(response.data) };
      this.setState({ messages, error: '', isLoading: false });
    })
      .catch((error) => {
        this.setState({ error, isLoading: false });
      });
  }

  renderTable() {
    if (this.state.isLoading && !this.state.error) return <Spinner />;
    else if (this.state.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.state.error)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    const getRows = () => Data.Selectors.getRows(this.state.messages);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const messages = Object.assign({}, this.state.messages, { sortColumn, sortDirection });
      this.setState({ messages });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.messages.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const messages = { ...this.state.messages, filters: newFilters };
      this.setState({ messages });
    };

    // Handle the row select function
    const onRowsSelected = (rows) => {
      const newRows = this.state.messages.rows;
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      const messages = { ...this.state.messages, rows: newRows };
      this.setState({ messages });
    };

    const FilePathFormatter = React.createClass({
      render() {
        return (
          this.props.value ?
            <a href={this.props.value} target="_blank" style={{ cursor: 'pointer' }}>{this.props.value}</a> :
            <span className="label label-danger">-</span>
        );
      },
    });

    const FromAdminFormatter = React.createClass({
      render() {
        return (
          // from_admin(0代表用户，1代表系统)
          String(this.props.value) === '0' ?
            <span>User</span> :
            <span>System</span>
        );
      },
    });

    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    // Column difinition
    const columns = [
      {
        key: 'communicate_num',
        name: 'Communicate Num',
        width: 130,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'FilePath',
        name: 'File Path',
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: FilePathFormatter,
      },
      {
        key: 'note',
        name: 'Note',
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'from_admin',
        name: 'Type',
        width: 80,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: FromAdminFormatter,
      },
      {
        key: 'create_time',
        name: 'Create Time',
        width: 95,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter,
      },
    ];

    return (
      <ContentWrapper>
        <Row>
          <div id="mobileUserMessagesManagement-dataGrid1">
            <ReactDataGrid
              rowKey="user_id"
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter />}
              headerRowHeight={50}
              rowHeight={25}
              onAddFilter={handleFilterChange}
              columns={columns}
              width={200}
              minHeight={tableHeight}
              rowGetter={rowGetter}
              rowsCount={getSize()}
            />
          </div>
        </Row>
        <Row className="total-users">
          <label>
            <Translate value="total_users" />:&nbsp;
            <span className="font-color-orange">{this.state.messages.rows.length}</span>
          </label>
        </Row>
      </ContentWrapper>
    );
  }

  setReplyModalVisibility(messageModalOpen = false) {
    this.setState({ messageModalOpen });
  }

  clickNew(e) {
    const { id } = this.context.router.params;
    e.preventDefault();
    this.setReplyModalVisibility(true);
    this.setState({ userId: id, replyMessage: '', replyFile: null });
  }

  handleChangeMessage(e) {
    this.setState({ replyMessage: e.target.value });
  }

  handleChangeFile(event) {
    this.setState({ replyFile: event.target.files[0] });
  }

  handleOnSubmit() {
    const { replyMessage, replyFile, userId } = this.state;
    const data = new FormData();
    data.append('pk', userId);
    data.append('note', replyMessage);
    data.append('FILE', replyFile);

    axios.post(
      USER_PUT_NOTE_URL,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then(() => {
      window.location.reload();
      alert('Reply success!');
      this.setState({
        messageModalOpen: false,
        replyMessage: '',
        replyFile: null,
        userId: '',
      });
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  }

  render() {
    return (
      //---------------
      // Begin HTML: Create New/Edit user_management
      //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="Admin" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="mobile_user_messages_management" />
          </Breadcrumb.Item>
          <ButtonToolbar
            style={{
              zIndex: 1,
              position: 'absolute',
              top: '10px',
              right: '10px',
            }}
          />
        </Breadcrumb>
        <Grid id="settings-user-management">
          <Panel className="position-relative table-collapse-fix">
            {
              !this.state.isLoading &&
              !this.state.error &&
                <ButtonToolbar className="table-buttons">
                  <Button
                    bsStyle="success"
                    className="marginLeftStyle"
                    onClick={(event) => {
                      this.clickNew(event);
                    }}
                  >
                    <em className="fa fa-plus marginRightStyle" /><Translate value="create_message" />
                  </Button>
                </ButtonToolbar>
            }
            {this.renderTable()}
          </Panel>
        </Grid>
        <SkyLightStateless
          dialogStyles={{ height: '800px', width: '75%', top: '29%', left: '38%'}}
          isVisible={this.state.businessUsersModalOpen}
          onCloseClicked={this.closeMessageModal}
          title="Business Users"
        >
          <BusinessUsersModal />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={{ height: '400px', width: '500px' }}
          isVisible={this.state.messageModalOpen}
          onCloseClicked={this.setReplyModalVisibility}
          title="Reply Message"
        >
          <span>{this.state.message}</span>
          <textarea
            rows={5}
            style={{ width: '100%', border: '1px solid #000000' }}
            value={this.state.replyMessage}
            onChange={this.handleChangeMessage}
          />
          <input
            style={{ border: '1px solid #aaa' }}
            type="file"
            name="file"
            onChange={this.handleChangeFile}
          />
          <Button
            bsStyle="success"
            onClick={() => { this.handleOnSubmit(); }}
            disabled={this.state.replyMessage === ''}
          >
            <Translate value="submit" />
          </Button>
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

export default UserManagement;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/mobileUserMessagesManagement.jsx